import styled from 'styled-components';

export const StatsGrid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  gap: 32px;
  max-width: 980px;
  width: 100%;
  margin: 32px auto -32px auto;
  position: relative;
  bottom: 60px;
  @media (max-width: 640px) {
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
  }
`;

export const StatCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
  min-width: 200px;
  max-width: 340px;
  flex: 1 1 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0 32px 0;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
  border: 2px solid transparent;
  &:hover, &:focus {
    box-shadow: 0 4px 24px 0 rgba(25,51,77,0.12);
    border: 2px solid #7B2639;
    transform: translateY(-4px) scale(1.02);
    outline: none;
  }
  @media (max-width: 640px) {
    min-width: 0;
    max-width: calc(50% - 12px);
    flex: 1 1 calc(50% - 12px);
    padding: 16px 0 14px 0;
  }
`;

export const StatIcon = styled.div`
  margin-bottom: 18px;
`;

export const StatNumber = styled.div`
  font-size: 2.6rem;
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  color: #223046;
  margin-bottom: 8px;
  @media (max-width: 640px) {
    font-size: 1.6rem;
    margin-bottom: 6px;
  }
`;

export const StatLabel = styled.div`
  font-size: 1.2rem;
  color: #6B7280;
  font-weight: 400;
  @media (max-width: 640px) {
    font-size: 0.85rem;
  }
`;


